<mat-spinner [mode]="mode" [value]="progress"></mat-spinner>
<p *ngIf="!customContent.innerHTML.trim()">loading...</p>
<div #customContent><ng-content></ng-content></div>
